import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import View from '../../../../../components/pdf/View'
import { Paragraph, SectionHeading } from './_shared/Prose'

/**
 * Seção 12 - Monitoramento da Exposição. Texto literal do modelo aprovado por Julia Buzzo
 * ("Modelo PGR 2026 - Banco Bradesco_Varejo"), item 12 (pág. 39).
 *
 * Conteúdo relocado do arquivo/slot "13" (`13.PlanoDeAcaoDefinicaoMonitoramentoSection.js`,
 * removido nesta revisão) — já estava correto e já rotulado internamente com `numero={12}`,
 * apenas vivia no slot de arquivo errado porque o "12" estava ocupado pela Matriz de Risco
 * duplicada da Seção 9.3 (ver nota em `10.ClassificacaoRiscosErgonomicoPsicossocialSection.js`
 * e o mapa completo em `PdfDocument.js`). Texto sem alteração de conteúdo.
 */
const MonitoramentoExposicaoSection = () => (
  <View id="12">
    <Separator weight={15} />
    <SectionHeading numero={12}>MONITORAMENTO DA EXPOSIÇÃO</SectionHeading>

    <Paragraph>
      Quando detectada qualquer forma de exposição ocupacional com potencial impacto à saúde dos funcionários, o
      coordenador do PCMSO deverá ser imediatamente comunicado. Da mesma forma, se houver suspeita clínica
      relacionada à exposição ambiental, caberá ao médico do trabalho acionar o responsável técnico pelo PGR para
      análise e proposição de intervenções corretivas.
    </Paragraph>
    <Paragraph>O monitoramento periódico será estabelecido conforme criticidade do risco e legislação vigente.</Paragraph>

    <Separator weight={15} />
  </View>
)

export default MonitoramentoExposicaoSection
